let goodsData = [{
	"id": 1000271,
	"name": "硬件开发",
	"name_title": "嵌入式开发",
	"model": "开发语言：c语言",
	"sku_info": [{
		"sku_id": 1000271,
		"ali_image": require('@/assets/img/products/develop/hard/harddevelop1.jpg'),
		"spec_json": {
			"show_name": ""
		}
	}, {
		"sku_id": 1000271,
		"ali_image": require('@/assets/img/products/develop/hard/harddevelop2.jpg'),
		"spec_json": {
			"show_name": ""
		}
	}]
}, {
	"id": 1000299,
	"name": "微信小程序开发",
	"name_title": "跨平台应用，管理蓝牙钥匙,上传开锁记录",
	"model": '开发语言：小程序',
	"sku_info": [{
		"sku_id": 1000299,
		"ali_image": require('@/assets/img/products/develop/soft/mini05.jpg'),
		"spec_json": {
			"show_name": ""
		}
	}, {
		"sku_id": 1000299,
		"ali_image": require('@/assets/img/products/software/wxMini/open_record.jpg'),
		"spec_json": {
			"show_name": ""
		}
	}]
}, {
	"id": 1000300,
	"name": "手机APP开发",
	"name_title": "管理蓝牙钥匙,上传开锁记录",
	"model": '开发语言：java',
	"sku_info": [{
			"sku_id": 1000300,
			"ali_image": require("@/assets/img/products/develop/soft/app3.jpg"),
			"spec_json": {
				"show_name": ""
			}
		},
		{
			"sku_id": 1000300,
			"ali_image": require("@/assets/img/products/develop/soft/app.jpg"),
			"spec_json": {
				"show_name": ""
			}
		}
	]
}, {
	"id": 1000302,
	"name": "微信公众号开发",
	"name_title": "为企业定制自己的公众号，展示产品",
	"model": '开发语言：html、css、js',
	"sku_info": [{
		"sku_id": 1000302,
		"ali_image": require("@/assets/img/products/develop/soft/gongzong1.jpg"),
		"spec_json": {
			"show_name": "灰色"
		}
	}]
},  {
	"id": 1000303,
	"name": "管理平台开发",
	"name_title": "web服务器平台前端、后端开发",
	"model": '开发语言：php、vue、html、css、js',
	"sku_info": [
	{
		"sku_id": 1000303,
		"ali_image": require("@/assets/img/products/develop/soft/web2.jpg"),
		"spec_json": {
			"show_name": ""
		}
	},
		{
		"sku_id": 1000303,
		"ali_image": require("@/assets/img/products/develop/soft/web3.jpg"),
		"spec_json": {
			"show_name": ""
		}
	}
	]
},  {
	"id": 1000304,
	"name": "机械设计",
	"name_title": "3D立体图纸设计、打印、开模",
	"model": '开发工具：solidword',
	"sku_info": [
	{
		"sku_id": 1000304,
		"ali_image": require("@/assets/img/products/develop/solidwork/solidwork1.jpg"),
		"spec_json": {
			"show_name": ""
		}
	},
	{
		"sku_id": 1000304,
		"ali_image": require("@/assets/img/products/develop/solidwork/solidwork2.jpg"),
		"spec_json": {
			"show_name": ""
		}
	}
	]
}
]

export default goodsData


// WEBPACK FOOTER //
// ./src/lib/developData.js